import styled from 'styled-components';

export const UnitContainer = styled.div`
  padding: 6px;
  margin-right: 6px;
`;
